import BaseFeature from '../../foundation/base/base';

class ToggleMegamenuExpand extends BaseFeature {
	constructor(element) {
		super(element);
		this.elm = element;
		this.megaBtn = element.querySelector('[data-megamenu-button]') || false;
		if (this.megaBtn !== false) {
			this.initDomCache();
			this.init();
		}
	}

	init() {
		this.addClickListener();
	}

	addClickListener() {
		this.megaBtn.addEventListener('click', () => {
			this.expanded = this.elm.hasAttribute('data-expanded');
			this.expanded = !this.expanded;
			this.handleToggle();
		});
	}

	handleToggle() {
		if (this.expanded) {
			this.elm.setAttribute('data-expanded', true);
			this.elm.setAttribute('aria-expanded', true);
			this.megaBtn.innerHTML = '<span>Menu</span> <span class="h-megamenu__closeicon"></span>';
			document.getElementById('h-megamenu--greyout').style.display = 'block';
		} else {
			this.elm.removeAttribute('data-expanded');
			this.elm.setAttribute('aria-expanded', false);
			this.megaBtn.innerHTML = '<span>Menu</span> <span class="h-megamenu__icon"><span class="h-megamenu__icon-bar"></span><span class="h-megamenu__icon-bar"></span><span class="h-megamenu__icon-bar"></span></span>';
			document.getElementById('h-megamenu--greyout').style.display = 'none';
		}
	}
}

export default ToggleMegamenuExpand;
